
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press",
      function () {
        return require("private-next-pages/press/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/press"])
      });
    }
  